<script>
export default {
  props: {
    name: String,
    active: Boolean,
  },
};
</script>

<template>
  <v-card
    :color="active ? 'secondary' : 'accent'"
    @click="$emit('select', name)"
  >
    <v-card-title>{{ name }}</v-card-title>
    <v-card-actions>
      <v-btn @click="$emit('edit', name)" variant="contained-text"
        >Edit Preset</v-btn
      >
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>